// clone node
document.addEventListener("DOMContentLoaded", function () {
    const mobileBreakpoint = 767;
    const original = document.getElementById("product-cover-original");
    const anchor = document.querySelector('[data-mobile-anchor="mattress-cover-area"]');
  
    if (window.innerWidth <= mobileBreakpoint && original && anchor) {
      const clone = original.cloneNode(true);
      clone.classList.remove("desktop-only");
      clone.classList.add("mobile-only");
      const mobileCoverSelect = clone.querySelector('product-cover-select.MattressSizeSelect');
      if (mobileCoverSelect) {
        mobileCoverSelect.classList.add('mobile-only');
      }
      const hiddenSelect = clone.querySelector('#ProductSelect-Cover-Hidden');
      if (hiddenSelect) {
        hiddenSelect.id = 'ProductSelect-Cover-Hidden-Mobile';
      }
      anchor.parentNode.insertBefore(clone, anchor.nextSibling);
      requestAnimationFrame(() => {
        updateCoverDropdownLabels();
      });
    } else {
      updateCoverDropdownLabels();
    }
  
    observeVariantChanges();
  });


  // label update
function updateCoverDropdownLabels() {
    const firstValue = document.querySelector('.first-variant')?.textContent.trim();
    const secondValue = document.querySelector('.second-variant')?.textContent.trim();
    const prices = [firstValue, secondValue];
  
    const selectIds = ['ProductSelect-Cover-Hidden', 'ProductSelect-Cover-Hidden-Mobile'];
  
    selectIds.forEach(selectId => {
      const hiddenSelect = document.getElementById(selectId);
      if (!hiddenSelect) return;
  
      const selectedValue = hiddenSelect.value;
      const isMobile = selectId.includes('Mobile');
  
      const containerSelector = isMobile
        ? 'product-cover-select.MattressSizeSelect.mobile-only'
        : 'product-cover-select.MattressSizeSelect:not(.mobile-only)';
  
      const coverButtons = document.querySelectorAll(`${containerSelector} .MattressSizeSelect__SizeBtn`);
  
      coverButtons.forEach((btn, index) => {
        const originalLabel = btn.getAttribute('data-label') || '';
        const baseLabel = originalLabel.split(' - ').pop().trim();
        const dynamicPrice = prices[index] || '';
        const newLabel = dynamicPrice ? `${dynamicPrice} - ${baseLabel}` : baseLabel;
        btn.setAttribute('data-label', newLabel);
        btn.innerHTML = `${baseLabel} <span class="option-price">${dynamicPrice}</span>`;
        if (btn.getAttribute('data-value') === selectedValue) {
          const selectedLabels = document.querySelectorAll(`${containerSelector} .MattressSizeSelect__Size`);
          selectedLabels.forEach(label => {
            label.innerHTML = `${baseLabel} <span class="option-price">${dynamicPrice}</span>`;
          });
        }
      });
    });
  }
  function observeVariantChanges() {
    const config = { characterData: true, subtree: true, childList: true };
    const observer = new MutationObserver(updateCoverDropdownLabels);
  
    ['.first-variant', '.second-variant'].forEach(selector => {
      const el = document.querySelector(selector);
      if (el) observer.observe(el, config);
    });
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    updateCoverDropdownLabels();
    observeVariantChanges();
  });

// cover popup code starts here
  document.addEventListener('DOMContentLoaded', function () {
    function handlePopupOpening(buttonClass, popupClass) {
      const openButtons = document.querySelectorAll(buttonClass);
      const closeButtons = document.querySelectorAll('.close-popup-js');

      openButtons.forEach((btn) => {
        btn.addEventListener('click', function () {
          const popup = btn.closest('section').querySelector(popupClass);
          if (popup) {
            popup.classList.remove('hidden');
          }
        });
      });

      closeButtons.forEach((btn) => {
        btn.addEventListener('click', function () {
          const popup = btn.closest(popupClass);
          if (popup) {
            popup.classList.add('hidden');
          }
        });
      });
    }

    handlePopupOpening('.open-cover-popup-js', '.cover-popup-js');
    handlePopupOpening('.open-cover-second-popup', '.cover-popup-second');
  });
